























import { Component, PropSync, Watch } from "vue-property-decorator";
import BaseAlert from "./template/BaseAlert.vue";

@Component({
  name: "return-component",
})
export default class ReturnComponent extends BaseAlert {
  @PropSync("httpResponse", { type: Object })
  public syncedHttpResponse!: object;

  private httpStatus: boolean = false;
  private msgType: string = "";
  private msg: object = {};
  private msgStr: string = "";
  private isMsgStr: boolean = false;

  public async handleReturn(): Promise<void> {
    const ret: any = this.syncedHttpResponse;

    if ((ret && ret.status === 400) || (ret && ret.status === 401)) {
      this.httpStatus = true;
      this.msgType = "danger";

      if (typeof ret.data !== "undefined") {
        if (typeof ret.data.errors !== "undefined") {
          const msg = ret.data.errors;
          this.isMsgStr = false;

          if (typeof msg === "object") {
            this.msg = msg;
          } else {
            this.isMsgStr = true;
            this.msgStr = msg;
          }
        } else {
          this.isMsgStr = true;
          this.msgStr = ret.data.message;
        }
      } else {
        this.isMsgStr = true;
        this.msgStr = ret.message;
      }
    } else if (ret && ret.status === 200) {
      this.httpStatus = true;
      this.msgType = "success";
      this.isMsgStr = true;
      this.msgStr = ret.message;
    }
  }

  @Watch("syncedHttpResponse")
  private onHttpResponseChanged(val: object): void {
    this.syncedHttpResponse = val;
    this.handleReturn();
  }

  private updateVisible(status: boolean): void {
    this.httpStatus = status;
  }
}
